import { Box, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import Heading from "../../AdminComponents/Common/Heading";
import TextInput from "../../Components/Common/TextInput";
import CustomButton from "../../Components/Common/CustomButton";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Dropdown from "../../AdminComponents/Common/Dropdown";
import { BASE_URL } from "../../Assets/Constants";
import { toast } from "react-toastify";

function BarcodeCreation() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { type } = useParams();
  const [inputValues, setInputValues] = useState({
    barcode: "",
    type: "", 
    experience: "",
  });
  const [adventureOptions, setAdventureOptions] = useState([]);
  const [ticketCategories, setTicketCategories] = useState([]);
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchTicketCategories = async () => {
      const loginData = JSON.parse(localStorage.getItem("adminData"));
      const token = loginData?.token;

      if (!token) {
        toast.error("Authentication token is missing");
        navigate('/login');
        return;
      }

      try {
        const response = await axios.get(`${BASE_URL}/admin/tickets`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const ticketTypes = response?.data?.ticketTypes || [];
        if (!Array.isArray(ticketTypes)) {
          throw new Error("Unexpected response format");
        }

        setTicketCategories(ticketTypes.map((ticket) => ({
          value: ticket._id,  
          label: ticket.name, 
        })));
      } catch (error) {
        console.error("Error fetching ticket categories:", error.message);
      }
    };

    fetchTicketCategories();
  }, []);

  useEffect(() => {
    const fetchAdventures = async () => {
      const loginData = JSON.parse(localStorage.getItem("adminData"));
      const token = loginData?.token;

      if (!token) {
        toast.error("Authentication token is missing");
        navigate('/login');
        return;
      }

      try {
        const response = await axios.get(`${BASE_URL}/admin/experiences`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const adventures = response?.data?.data;
        if (!Array.isArray(adventures)) {
          throw new Error("Unexpected response format");
        }

        setAdventureOptions(adventures.map((item) => ({
          value: item._id,
          label: item.name,
        })));
      } catch (error) {
        console.error("Error fetching adventure options:", error.message);
      }
    };

    fetchAdventures();
  }, []);

  useEffect(() => {
    setInputValues({
      barcode: state?.barcodeDetails?.data?.barcode || "",
      type: state?.barcodeDetails?.data?.type || "",
      experience: state?.barcodeDetails?.data?.experience?._id || "",
    });
  }, [state]);

  const handleSaveBarcode = async () => {
    setErrors([]);
    const loginData = JSON.parse(localStorage.getItem("adminData"));
    const token = loginData?.token;

    if (!token) {
      toast.error("Authentication token is missing");
      navigate('/login');
      return;
    }

    const payload = {
      experience: inputValues.experience,
      type: inputValues.type,
      barcode: inputValues.barcode,
    };

    setLoading(true);
    try {
      const url =
        type === "add"
          ? `${BASE_URL}/admin/barcode/store`
          : `${BASE_URL}/admin/barcode/${state?.barcodeDetails?.data?._id}/update`;

      await axios({
        method: type === "add" ? "post" : "put",
        url,
        data: payload,
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success(`Barcode ${type === "add" ? "added" : "updated"} successfully`);
      navigate(-1);
    } catch (error) {
      console.error("Error saving barcode:", error?.response?.data);
      setErrors(error?.response?.data?.errors || []);
      toast.error("Failed to save barcode. Please check the errors.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Heading back={true} label={type === "add" ? "Add Barcode" : "Edit Barcode"} />
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "80vh" }}>
        <Box width={{ md: "50%", xs: "100%" }}>
          <TextInput
            bgColor={"#f9f9f9"}
            label={"Barcode"}
            placeholder={"Enter Barcode"}
            value={inputValues.barcode}
            onChange={(e) => setInputValues({ ...inputValues, barcode: e.target.value })}
          />

          <Dropdown
            options={ticketCategories}
            label={"Category"}
            placeholder="Select Category"
            onChange={(e) => {
              const selectedCategory = ticketCategories.find((item) => item.value === e.target.value);
              setInputValues({
                ...inputValues,
                type: selectedCategory?.label || "",
              });
            }}
            value={ticketCategories.find((item) => item.label === inputValues.type)?.value || ""}
          />

          <Dropdown
            options={adventureOptions}
            label={"Adventure"}
            placeholder="Select Adventure"
            onChange={(e) => setInputValues({ ...inputValues, experience: e.target.value })}
            value={inputValues.experience}
          />

          <CustomButton cursor="pointer" disabled={loading} onClick={handleSaveBarcode}>
            {loading ? <CircularProgress size={25} sx={{ color: "white" }} /> : type === "add" ? "Add Barcode" : "Update"}
          </CustomButton>
        </Box>
      </Box>
    </Box>
  );
}

export default BarcodeCreation;
